/** Paylaşım tipi – backend shareType değerleri */
export enum LibraryShareType {
  EVERYONE = 0,
  ADMINS = 1,
  PRIVATE = 2,
}

/** Backend GET /api/admin/library/items – raw item (folder or file) */
export interface LibraryItemApiFile {
  id: string;
  filename: string;
  originalName: string;
  mimeType: string;
  size: number;
  durationMinutes?: number;
  createdAt: string;
  /** İndirme linki (presigned URL vb.) */
  downloadUrl?: string;
  expiresAt?: string;
  expiresIn?: number;
}

export interface LibraryItemApiCreatedByUser {
  id: string;
  firstName: string;
  lastName: string;
}

export interface LibraryItemApi {
  type: "folder" | "file";
  id: string;
  parentItemId: string | null;
  shareType: LibraryShareType;
  createdByUserID?: string;
  createdByUser?: LibraryItemApiCreatedByUser;
  createdAt: string;
  updatedAt: string;
  name: string;
  fileID?: string;
  file?: LibraryItemApiFile;
  /** İndirme linki (belge için) */
  downloadUrl?: string;
}

export interface LibraryItemsMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

/** Response: data = items array, meta at root (backend format) */
export interface LibraryItemsResponse {
  success: boolean;
  status: number;
  data: LibraryItemApi[];
  message?: string;
  meta: LibraryItemsMeta;
}

/** UI: folder after mapping from API */
export interface LibraryFolderItem {
  id: string;
  name: string;
  lastUpdatedFormatted: string;
  createdAt: string;
  uploadedBy?: string;
}

/** UI: file/document after mapping from API */
export interface LibraryFileItem {
  id: string;
  name: string;
  fileType: string;
  uploadedBy: string;
  lastUpdatedFormatted: string;
  fileSize: string;
  sharedWithCount?: number;
  createdAt: string;
  /** İndirme URL'i – İndir butonunda kullanılır */
  downloadUrl?: string;
}

/** Tek API çağrısında dönen karışık öğe (klasör veya dosya) */
export type LibraryItem =
  | (LibraryFolderItem & { kind: "folder" })
  | (LibraryFileItem & { kind: "file" });

/** Query params for list (search/date – use if backend supports) */
export interface LibraryFilters {
  search?: string;
  updatedAfter?: string;
}

/** POST /api/admin/library/items/folders – create folder body */
export interface CreateFolderPayload {
  name: string;
  parentItemId?: string | null;
  shareType: LibraryShareType;
  sharedUserIds?: string[];
  sharedDepartmentIds?: string[];
}

/** Belge yükleme parametreleri: files ile yükle veya önceden yüklenmiş fileIds ile ekle */
export interface UploadDocumentParams {
  /** Yüklenecek dosyalar (yoksa fileIds kullanılır) */
  files?: File[];
  /** Önceden yüklenmiş dosya id'leri (seçimde hemen yükleme akışında) */
  fileIds?: string[];
  parentItemId?: string | null;
  shareType: LibraryShareType;
  sharedUserIds?: string[];
  sharedDepartmentIds?: string[];
}
